export const UPDATE_ALBUM_FOLDER_OBJECT_SEARCH =
  'UPDATE_ALBUM_FOLDER_OBJECT_SEARCH';

export const updateAlbumFolderObjectSearch = (searchQuery, entityId) => ({
  type: UPDATE_ALBUM_FOLDER_OBJECT_SEARCH,
  searchQuery,
  entityId,
});
